export const FormatDate = (date) => {
  const newDate = new Date(date).toLocaleDateString("id-ID", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return newDate;
};
